import { inject, observer } from "mobx-react";
import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { SecuredComponentProps } from "../Secured";
import { RelativeLink } from "../RelativeLink/RelativeLink";
import { linkButtonStyles } from "./SecuredMenuLinkButton";
import { WithStyles } from "@material-ui/core";
import EditIcon from "@material-ui/icons/EditOutlined";
import withStyles from "@material-ui/core/styles/withStyles";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

export interface EditButtonProps extends WithStyles<typeof linkButtonStyles> {
  link: string;
  title: string;
}

@inject("security", "i18n")
@observer
export class SecuredEditButtonComponent extends React.Component<
  EditButtonProps & SecuredComponentProps
> {
  public render() {
    // @ts-ignore
    const { classes, security, requiredAccess, i18n } = this.props;
    const finalRequiredAccess = requiredAccess || "editable";
    const canEdit = security && security[finalRequiredAccess]();
    const title = canEdit
      ? i18n.t("lego:views.index.row.edit", {
          view: "Edit"
        })
      : i18n.t("lego:views.index.row.view", { view: "View" });

    return (
      <RelativeLink to={this.props.link}>
        <MenuItem>
          <div className={classes.menuItem}>
            <div className={classes.title}>{title}</div>
            <div className={classes.icon}>
              {canEdit ? (
                <EditIcon color={"inherit"} />
              ) : (
                <DescriptionOutlinedIcon color={"inherit"} />
              )}
            </div>
          </div>
        </MenuItem>
      </RelativeLink>
    );
  }
}

export const SecuredEditButton = withStyles(linkButtonStyles, {
  withTheme: true
})(SecuredEditButtonComponent);
